import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
    dashboardData: {},
    type: "all",
    selectedMonth: dayjs().format("MM-YYYY")
}

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setDashboardData(state, action) {
            state.dashboardData = action.payload
        },
        setType(state, action) {
            state.type = action.payload
        },
        setSelectedMonth(state, action) {
            state.selectedMonth = action.payload
        }
    }
})

export const { setDashboardData, setType, setSelectedMonth } = dashboardSlice.actions

export default dashboardSlice.reducer